var _rect, _rect2, _rect3, _circle, _rect4, _circle2, _rect5, _path, _path2, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWizard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 110,
    width: 61,
    height: 26,
    rx: 7.31429,
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 23,
    width: 22.3333,
    height: 8,
    fill: "#4C6170"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136.333,
    cy: 27,
    r: 5,
    fill: "#4C6170"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.333,
    y: 23,
    width: 22.3333,
    height: 8,
    fill: "#4C6170"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.667,
    cy: 27,
    r: 4.5,
    fill: "white",
    stroke: "#4C6170",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193.667,
    y: 23,
    width: 22.3333,
    height: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 50C105 46.6863 107.686 44 111 44H208C211.314 44 214 46.6863 214 50V60C214 63.3137 211.314 66 208 66H111C107.686 66 105 63.3137 105 60V50Z",
    fill: "white",
    stroke: "#4C6170",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111 78H208C211.314 78 214 80.6863 214 84V94C214 97.3137 211.314 100 208 100H111C107.686 100 105 97.3137 105 94V84C105 80.6863 107.686 78 111 78Z",
    fill: "white",
    stroke: "#4C6170",
    strokeWidth: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizard);
export default __webpack_public_path__ + "static/media/wizard.0ad2f42abbd6705a9eced0583ebe485a.svg";
export { ForwardRef as ReactComponent };